import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, forwardRef } from "react";
import { useStringMap } from "../../utilities/string-map/useStringMap";
import { AppMenuList } from "../app-menu-list/AppMenuList";
import { AppNavOverflowButton } from "../app-menu-button/AppNavOverflowButton";
import { OverflowCollapse } from "../../overflow-collapse/OverflowCollapse";
import * as Styled from "./AppNav.styled";
import { AppNavMobile } from "./AppNavMobile";
import { AppNavListItem } from "./AppNavListItem";
import { useIsMobile } from "./useIsMobile";
import { stringMapDefault } from "./AppNav.stringMap";
const componentName = "AppNav";
export const AppNav = forwardRef((props, ref) => {
    const { children, items, layoutTrigger, onNavClick = () => { }, renderOverflow, priority = defaults.priority, stringMap: stringMapProp, ...otherProps } = props;
    const stringMap = useStringMap(componentName, { stringMapDefault, stringMapProp });
    const defaultRenderOverflow = (children) => (_jsx(AppNavOverflowButton, { overflowListItems: children, 
        // TODO FIX THIS so setisOpen is not required
        overlay: ({ isOpen, closeAndReturnFocus }) => (_jsx(Styled.AppNavOverflowWrapper, { children: _jsx(AppMenuList, { children: children.map((child) => cloneElement(child, {
                    isOverflowed: true,
                    isOpen,
                    setIsOpen: (isOpen) => !isOpen && closeAndReturnFocus()
                })) }) })), stringMap: {
            overflowIconButton: stringMap.overflowIconButton
        } }));
    // Set selected item so useUpdateIndicatorOnEvents gets triggered
    const handleNavClick = (event) => {
        onNavClick && onNavClick(event);
    };
    // If mobile then return AppNavMobile instead of regular nav
    const { isMobile } = useIsMobile();
    if (isMobile && priority === "primary" && items) {
        return (_jsx(AppNavMobile, { items: items, stringMap: {
                mobileMenuButtonTooltip: stringMap.mobileMenuButtonTooltip,
                mobileMenuIcon: stringMap.mobileMenuIcon
            } }));
    }
    return (_jsx(Styled.AppNav, { "data-testid": "AppNav", ref: ref, onClick: handleNavClick, priority: priority, ...otherProps, children: _jsxs(Styled.AppNavFocusList, { shouldFocusMatchOnType: false, children: [children, items && (_jsx(OverflowCollapse
                // @ts-expect-error TODO: figure out how to fix this
                , { 
                    // @ts-expect-error TODO: figure out how to fix this
                    renderOverflow: renderOverflow ? renderOverflow : defaultRenderOverflow, layoutTrigger: layoutTrigger ? layoutTrigger : "", wrapperElement: "ul", overflowElement: "li", "aria-label": stringMap.navList, shouldCollapseAll: Boolean(isMobile), priority: priority, children: items.map((item, index) => (_jsx(AppNavListItem, { label: item.label, href: item.href, icon: item.icon, isActive: item.isActive, onClick: item.onClick, priority: priority }, index))) }))] }) }));
});
const defaults = {
    priority: "primary"
};
AppNav.defaultProps = defaults;
AppNav.displayName = componentName;
